<template>
  <div :class="scope.clsPrefix">
    <div class="header-left">
      <div class="main-title">{{ title }}</div>
      <div class="chat-btn" @click="openDrawer">
        <i class="el-icon-chat-dot-square"></i>
        <span>立即对话</span>
      </div>
      <!-- <div class="sub-title">生产经营协同中枢</div> -->
    </div>
    <div class="header-right">
      <span class="datetime">{{ currentDateTime }}</span>
      <span class="time">{{ currentTime }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderCard',
  props: {
    // 工作台标题：默认 CEO 工作台，其他数字人（如能源站长）可通过 prop 覆盖
    title: {
      type: String,
      default: 'CEO智擎工作台'
    }
  },
  data() {
    return {
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-header-card'
      },
      currentDateTime: '',
      currentTime: '',
      isDrawerMode: window.innerWidth < 1750
    }
  },
  created() {
    this.updateDateTime()
    this.timer = setInterval(() => {
      this.updateDateTime()
    }, 1000)
    window.addEventListener('resize', this._checkDrawerMode)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
    window.removeEventListener('resize', this._checkDrawerMode)
  },
  methods: {
    _checkDrawerMode() {
      this.isDrawerMode = window.innerWidth < 1750
    },
    openDrawer() {
      if (typeof window.openDrawer === 'function') {
        window.openDrawer()
      }
    },
    updateDateTime() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')
      const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      const weekDay = weekDays[now.getDay()]
      this.currentDateTime = `${year}-${month}-${day}     ${weekDay}`
      this.currentTime = `${hours}:${minutes}:${seconds}`
    }
  }
}
</script>

<style lang="scss" scoped>
$class-prefix: "rvc-cosmoplat-workspace-header-card";
.#{$class-prefix} {
  display: flex;
  // align-items: center;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px 0px;
  padding-top: 0;
  // background: linear-gradient(135deg, #4A5FF3 0%, #6B7EFF 100%);
  border-radius: 8px;
  box-sizing: border-box;
}
.header-left {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
}
.main-title {
  font-size: 20px;
  font-weight: 700;
  color: #333;
  font-family: PingFangSC-Bold;
}
.chat-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: 9px;
  padding: 5px 16px;
  border: 1px solid #4a5ff3;
  border-radius: 4px;
  font-size: 12px;
  color: #4a5ff3;
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 0.2s;
}
.chat-btn i {
  font-size: 12px;
}
.sub-title {
  font-size: 14px;
  color: #595959;
  font-family: PingFangSC-Regular;
}
.header-right {
  display: flex;
  align-items: center;
}
.datetime {
  font-size: 14px;
  color: #595959;
  font-family: PingFangSC-Regular;
  letter-spacing: 1px;
}
.time {
  font-size: 16px;
  color: #333;
  font-family: PingFangSC-Regular;
  // letter-spacing: 1px;
  font-weight: 600;
  margin-left: 16px;
}
</style>
